// extracted by mini-css-extract-plugin
export default {"editableCompetencyProfile":"RRC5TxrY6k1iHhYRG6qQ","introductionText":"coqm_MAcbZZZgBp1jDgA","pagedCompetenciesContent":"JkdJs52XYhj0NPrbgGZw"};